// extracted by mini-css-extract-plugin
export default {"main":"main--15A9Qe-","heading":"heading--2SidLBX","mainRight":"mainRight--2SGwuyR"};